import {InputTypes, ValueTypes, IFieldDefinition, FieldViews} from 'app/interfaces';
import { Validators } from '@angular/forms';
import { fieldsMap as resourceFieldMap} from '../trip_resources/fields';
import { IDataContainerService } from 'app/interfaces/data-container.interface';
import { cloneFieldDefinition } from 'app/helpers/field.helper';

const fieldsMap: Map<string, IFieldDefinition> = new Map();

fieldsMap.set('document_file_id', {
	key: 'document_file_id',
	name: 'File',
	inputType: InputTypes.TEXT,
	valueType: ValueTypes.STRING,
	getDisplayValue(record: any): string{
		return record.document_file.file_name;
	}
});

fieldsMap.set('file_name', {
	key: 'document_file_id',
	name: 'Nome File',
	valueType: ValueTypes.STRING,
	getDisplayValue(record: any): string{
		return record.document_file.file_name;
	}
});

fieldsMap.set('files', {
	key: 'files',
	name: 'File',
	inputType: InputTypes.MULTIPLE_FILE,
	valueType: ValueTypes.ARRAY,
});

fieldsMap.set('download_count', {
	key: 'download_count',
	name: 'Numero di download',
	inputType: InputTypes.NUMBER,
	valueType: ValueTypes.NUMBER,
});

fieldsMap.set('duration_in_seconds', {
	key: 'duration_in_seconds',
	name: 'Durata in secondi',
	inputType: InputTypes.NUMBER,
	valueType: ValueTypes.NUMBER,
	skipIf(record, dataContainerService) {
		return dataContainerService.getValueFromKeyPath('trip_resources.record.properties.resource_sub_types.value') != 'AUDIOGUIDA';
	}
});

fieldsMap.set('lang', {
	key: 'lang',
	name: 'Lingua',
	inputType: InputTypes.SELECT,
	valueType: ValueTypes.STRING,
	defaultValue(): any{ return 'it'; },
	options: [
		{
			label: 'Italiano',
			value: 'it'
		},
		{
			label: 'Inglese',
			value: 'en'
		},
		{
			label: 'Spagnolo',
			value: 'es'
		},
		{
			label: 'Francese',
			value: 'fr'
		},
		{
			label: 'Tedesco',
			value: 'de'
		},
		{
			label: 'Giapponese',
			value: 'ja'
		},
		{
			label: 'Cinese',
			value: 'zh'
		},
		{
			label: 'Russo',
			value: 'ru'
		},
		{
			label: 'Portoghese',
			value: 'pt'
		}
	],
	skipIf(record, dataContainerService) {
		return dataContainerService.getValueFromKeyPath('trip_resources.record.properties.resource_sub_types.value') != 'AUDIOGUIDA';
	}
});

fieldsMap.set('downloaded_filter', {
	key: 'downloaded_type',
	name: 'Stato',
	inputType: InputTypes.SELECT,
	valueType: ValueTypes.STRING,
	defaultValue(): any{ return ''; },
	options: [
		{
			label: 'Tutti',
			value: ''
		},
		{
			label: 'Scaricati',
			value: 'downloaded'
		},
		{
			label: 'Non Scaricati',
			value: 'not_downloaded'
		}
	]
});

export {fieldsMap};
